import {UmpirePublicationOptions} from '../umpire-publication-options';
import {UmpireQuiz} from '../umpire-quiz';
import {UmpireQuizPrize} from '../umpire-quiz-prize';
import {UmpireQuizUserAttempt} from '../umpire-quiz-user-attempt';

export class UmpireQuizRanking implements UmpirePublicationOptions {
  id!: string | null;

  type!: 'quiz_ranking';

  client_id!: string | null;

  is_draft!: boolean;

  kind!: string;

  name = 'Quiz Ranking';

  publication_time!: string | null;

  published_at!: string | null;

  quiz!: UmpireQuiz | null;

  quizzes!: UmpireQuiz[];

  quiz_prizes!: UmpireQuizPrize[];

  quiz_user_attempts!: UmpireQuizUserAttempt[];

  relationshipNames!: string[];

  slug!: string | null;
}
